export const tr = {
    'disabled-note': 'Maksimum {count} sözcük grubu oluşturulabilir',
    generate: 'Kombinasyonlar oluştur',
    'note-expanded-mode':
        'Anahtar sözcük grubu birleştirici, eklenen sözcük gruplarını farklı kombinasyonlarda karıştırarak yeni anahtar sözcük grupları oluşturmanızı sağlar. En fazla 7 sözcük grubu ekleyebilirsiniz.',
    'note-hidden-mode': 'En fazla 7 sözcük grubu karıştırarak yeni anahtar sözcük grupları oluşturabilirsiniz.',
    title: 'Anahtar sözcük grubu birleştirici'
};
